import Tabs from "../../Components/Tabs";
import PageTitle from "../../Components/UI/PageTitle";
import WalletHistory from "../../Components/WalletHistory/WalletHistory";
import WalletManagementAction from "../../Components/WalletManagementAction";
import { WALLET_HISTORY_TABS } from "../../constants/globals";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const WalletManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const [currentTab, setCurrentTab] = useState(
    queryParams.get("tab") || "Action"
  );
  useEffect(() => {
    const params = new URLSearchParams();
    params.set("tab", currentTab);

    navigate({ search: params.toString() });
  }, [currentTab, navigate]);

  return (
    <>
      <PageTitle title="Wallet Management" />

      <div className="bg-white flex flex-col mt-4">
        <Tabs
          options={WALLET_HISTORY_TABS}
          onTabClick={setCurrentTab}
          currentTab={currentTab}
        />
        {currentTab === "Action" ? (
          <WalletManagementAction />
        ) : (
          <WalletHistory currentTab={currentTab} />
        )}
      </div>
    </>
  );
};

export default WalletManagement;
